import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { debounceTime, map, take, tap } from 'rxjs/operators';

import { HandleErrorService } from '../../interceptors/handle-error.service';
import { SharedServiceService } from '../../services/shared-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor(
    private readonly handleErrorS: HandleErrorService,
    private sharedS: SharedServiceService
  ) { }

  private validateAuthUser = (): Observable<boolean> =>
    combineLatest([
      this.isJwtLocal()
      , this.sharedS.isUrlWithTokenWA$
    ])
      .pipe(map(resp => resp[0] || resp[1]));

  private isJwtLocal = (): Observable<boolean> =>
    this.handleErrorS.getToken$()
      .pipe(
        debounceTime(500),
        map(jwt => jwt ? true : false),
      )

  canLoad(): Observable<boolean> {
    return this.validateAuthUser()
      .pipe(
        tap(estado => {
          if (!estado) {
            this.sharedS.clearData('/home');
            this.sharedS.loadingBottleDismiss();
          }
        }),
        take(1)
      );
  }

  canActivate(): Observable<boolean> {
    return this.validateAuthUser()
      .pipe(
        tap(estado => {
          if (!estado) {
            this.sharedS.clearData('/home');
            this.sharedS.loadingBottleDismiss();
          }
        })
      );
  }
}
